import AnimSection from "../AnimSection/AnimSection";
import "./Contact.css";
import { NAV_LINKS } from "../../utils/constants";

export default function ContactTemplate({ formData, sent, onChange, onSubmit, loading, error }) {
  return (
    <section id={NAV_LINKS[3].id} className="contact">
      <div className="section">

        <AnimSection>
          <div className="contact__header">
            <span className="section-label">Hai să vorbim</span>
            <h2 className="section-title">Audit gratuit pentru firma ta</h2>
            <p className="contact__subtitle">
              Spune-mi ce procese repetitive te consumă și îți spun în 24h dacă și cum le
              putem automatiza.
            </p>
          </div>
        </AnimSection>

        <AnimSection delay={100}>
          <div className="contact__form-wrapper">
            {sent ? <SuccessMessage /> : (
              <ContactForm
                formData={formData}
                onChange={onChange}
                onSubmit={onSubmit}
                loading={loading}
                error={error}
              />
            )}
          </div>
        </AnimSection>

      </div>
    </section>
  );
}

function SuccessMessage() {
  return (
    <div className="contact__success">
      <span className="contact__success-icon">✅</span>
      <h3 className="contact__success-title">Mesajul dvs. a fost trimis!</h3>
      <p className="contact__success-desc">
        Vă vom contacta în cel mai scurt timp posibil. 
      </p>
    </div>
  );
}

function ContactForm({ formData, onChange, onSubmit, loading, error }) {
  return (
    <form className="contact__form" onSubmit={onSubmit}>
      {error && <div className="contact__error">{error}</div>}
      <div className="contact__form-row">
        <input
          name="name"
          placeholder="Numele tău"
          required
          value={formData.name}
          onChange={onChange}
          disabled={loading}
        />
        <input
          name="email"
          type="email"
          placeholder="Email"
          required
          value={formData.email}
          onChange={onChange}
          disabled={loading}
        />
      </div>
      <input
        name="company"
        placeholder="Firma (opțional)"
        value={formData.company}
        onChange={onChange}
        disabled={loading}
      />
      <textarea
        name="message"
        rows={5}
        placeholder="Descrie ce procese manuale te consumă cel mai mult..."
        required
        value={formData.message}
        onChange={onChange}
        disabled={loading}
      />
      <button type="submit" className="btn-primary contact__submit" disabled={loading}>
        {loading ? "Se trimite..." : "Trimite mesajul →"}
      </button>
      <p className="contact__disclaimer">
        Fără spam. Fără obligații. Audit complet gratuit.
      </p>
    </form>
  );
}
